import React from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material';
import logo from '../../../assets/icons/logo.png'
import theme from '../../../theme';

function CustomerReviewComponent() {

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: isMobile ? "10px" : "20px",
      }}
    >
      <Typography
        variant='p'
        sx={{
          fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
          fontWeight: 700,
          fontSize: isMobile ? "14px" : "18px", // Adjust font size for mobile
          textAlign: "center",
        }}
      >
        "Real Stories. Real Style. See what our customers are saying!"
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // Stack boxes on mobile
          marginTop: "40px",
          alignItems: isMobile ? "center" : "flex-start", // Center on mobile
          justifyContent: isMobile ? "center" : "space-evenly",
          gap: isMobile ? "20px" : "0", // Add spacing between boxes on mobile

        }}
      >
        <Box
          sx={{
            width: isMobile ? "90%" : "23%", // Full width on mobile
            padding: "20px",
            backgroundColor: theme.palette.secondary.backgroundColor,
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            borderRadius: "15px",
            boxShadow: isMobile
              ? "4px 6px 18px 6px rgba(0,0,0,0.1)" // Lighter shadow on mobile
              : "8px 11px 34px 14px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="p"
            sx={{
              fontFamily: `'Myanmar Text','Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              fontSize: isMobile ? "12px" : "16px", // Smaller font size for mobile
            }}
          >
            MasterBladeMM က ဘလိတ်ဒါးဆူးကြိုးတွေ အရည်အသွေးကောင်းပြီး တပ်ဆင်ပြီးနောက်ကာကွယ်မှုက ယုံကြည်ရပါတယ်။ အိမ်ခြံမှာ တပ်ဆင်ပေးတဲ့အခါ အလုပ်သေချာပြီး လိုအပ်တဲ့ပစ္စည်းတွေကိုလည်း မခိုးမကပ်ဘဲ သေချာသုံးပေးတာကြောင့် စိတ်ချရပါတယ်။
          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: isMobile ? "8px" : "10px", // Adjust font size
                fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              }}
            >
              MasterBladeMM
            </p>
          </Box>
        </Box>

        <Box
          sx={{
            width: isMobile ? "90%" : "23%", // Full width on mobile
            padding: "20px",
            backgroundColor: theme.palette.secondary.backgroundColor,
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            borderRadius: "15px",
            boxShadow: isMobile
              ? "4px 6px 18px 6px rgba(0,0,0,0.1)" // Lighter shadow on mobile
              : "8px 11px 34px 14px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="p"
            sx={{
              fontFamily: `'Myanmar Text','Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              fontSize: isMobile ? "12px" : "16px", // Smaller font size for mobile
            }}
          >
            စက်ရုံဘေးကာရံတပ်ဆင်ရာမှာ MasterBladeMM ကိုယူထားပါတယ်။ ဆက်ဆံရေးကောင်းပြီး အချိန်တိကျတဲ့အတွက် လုပ်ငန်းအချိန်ဇယားနဲ့ကိုက်ညီပါတယ်။ ဘလိတ်ဒါးဆူးကြိုးစနစ်က တင်းကျပ်ပြီး တပ်ဆင်ပြီးနောက် စိတ်ချရလို့ ယုံကြည်စိတ်ချမိပါတယ်။
          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: isMobile ? "8px" : "10px", // Adjust font size
                fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              }}
            >
              MasterBladeMM
            </p>
          </Box>
        </Box>

        <Box
          sx={{
            width: isMobile ? "90%" : "23%", // Full width on mobile
            padding: "20px",
            backgroundColor: theme.palette.secondary.backgroundColor,
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            borderRadius: "15px",
            boxShadow: isMobile
              ? "4px 6px 18px 6px rgba(0,0,0,0.1)" // Lighter shadow on mobile
              : "8px 11px 34px 14px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="p"
            sx={{
              fontFamily: `'Myanmar Text','Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              fontSize: isMobile ? "12px" : "16px", // Smaller font size for mobile
            }}
          >
            အိမ်တိုင်ရာရောက် အခမဲ့စစ်ဆေးပေးပြီး လိုအပ်ချက်ကို အသေးစိတ်ညှိနှိုင်းပေးတာက အရမ်းကောင်းပါတယ်။ မီးမရတဲ့နေရာတွေမှာ မီးစက်နဲ့ လာတပ်ဆင်ပေးပြီး အလုပ်ပြီးစီးမှုလည်း သေချာပါတယ်။ စျေးနှုန်းနှင့်ဝန်ဆောင်မှု တန်ဖိုးရှိပါတယ်။

          </Typography>

          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                width: "25px",
                height: "25px",
                objectFit: "contain",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: isMobile ? "8px" : "10px", // Adjust font size
                fontFamily: `'Amiko', 'Roboto', 'Instrument Sans', sans-serif`,
              }}
            >
              MasterBladeMM
            </p>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CustomerReviewComponent
